import { Component, computed, inject } from '@angular/core';

import { ActiveNotification } from '../../models/responses/notifications.response';
import { NotificationsService } from '../../services/common/notifications.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [],
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent {
  private readonly service = inject(NotificationsService);

  readonly banners = this.service.banners;
  readonly activePopup = computed<ActiveNotification | null>(() => this.service.popups()[0] ?? null);

  dismiss(id: string, forever = false): void {
    this.service.dismiss(id, forever);
  }

  openLink(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
